<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>

      <template slot="incidentType" slot-scope="{ row }">
        {{ incidentTypeLabel(row.incidentType) }}
      </template>
      <template slot="incidentStatus" slot-scope="{ row }">
        <el-tag size="small" :type="statusTagType(row.incidentStatus)">{{ statusLabel(row.incidentStatus) }}</el-tag>
      </template>
      <template slot="eventLevel" slot-scope="{ row }">
        {{ eventLevelLabel(row.eventLevel) }}
      </template>

      <template slot-scope="{ row }" slot="menu">
        <el-button icon="el-icon-view" size="small" type="text" @click="showEventDetail(row)">详情</el-button>
        <el-button v-if="showAction(row, 'canSubmit')" icon="el-icon-position" size="small" type="text" @click="submitAction(row)">上报</el-button>
        <el-button v-if="showAction(row, 'canStartPlan')" icon="el-icon-s-flag" size="small" type="text" @click="openStartPlan(row)">启动应急预案</el-button>
        <el-button v-if="showAction(row, 'canNotifySafety')" icon="el-icon-message" size="small" type="text" @click="notifySafetyAction(row)">通知安环部</el-button>
        <el-button v-if="showAction(row, 'canClose')" icon="el-icon-circle-check" size="small" type="text" @click="openClose(row)">结束事件</el-button>
        <el-button v-if="showAction(row, 'canBack')" icon="el-icon-back" size="small" type="text" @click="backAction(row)">退回</el-button>
        <el-button v-if="showAction(row, 'canFalseAlarm')" icon="el-icon-warning-outline" size="small" type="text" @click="falseAlarmAction(row)">误报</el-button>
      </template>
    </avue-crud>

    <dialog-reset slotShow height="70vh" top="5vh" width="80%" title="应急工单详情" :visible.sync="eventDetailVisible">
      <div v-loading="eventDetailLoading" class="event-detail-dialog">
        <template v-if="eventDetail">
          <div class="detail-section">
            <div class="detail-section__title">基础信息</div>
            <div class="detail-grid">
              <div v-for="item in detailFields" :key="item.label" class="detail-item" :class="{ 'detail-item--wide': item.wide }">
                <span class="detail-item__label">{{ item.label }}</span>
                <span class="detail-item__value">{{ item.value || '-' }}</span>
              </div>
            </div>
          </div>

          <div v-if="imageList(eventDetail.sitePhotos).length" class="detail-section">
            <div class="detail-section__title">现场照片</div>
            <div class="image-list">
              <el-image v-for="(url, index) in imageList(eventDetail.sitePhotos)" :key="url + index" class="detail-image" :src="url" :preview-src-list="imageList(eventDetail.sitePhotos)" fit="cover">
                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
              </el-image>
            </div>
          </div>

          <div v-if="imageList(eventDetail.closePhotos).length" class="detail-section">
            <div class="detail-section__title">处置过程照片</div>
            <div class="image-list">
              <el-image v-for="(url, index) in imageList(eventDetail.closePhotos)" :key="url + index" class="detail-image" :src="url" :preview-src-list="imageList(eventDetail.closePhotos)" fit="cover">
                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
              </el-image>
            </div>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">流程记录</div>
            <el-table :data="detailFlowRecords" border size="small" empty-text="暂无流程记录">
              <el-table-column label="环节" prop="nodeName" width="130" show-overflow-tooltip />
              <el-table-column label="动作" prop="actionName" width="120" show-overflow-tooltip />
              <el-table-column label="操作人" prop="operatorName" width="120" show-overflow-tooltip />
              <el-table-column label="部门" prop="operatorDeptName" width="140" show-overflow-tooltip />
              <el-table-column label="意见" prop="opinion" min-width="220" show-overflow-tooltip />
              <el-table-column label="操作时间" prop="operateTime" width="170" show-overflow-tooltip />
            </el-table>
          </div>
        </template>
        <el-empty v-else-if="!eventDetailLoading" description="暂无详情数据" />
      </div>
      <span slot="dialog_footer">
        <el-button @click="eventDetailVisible = false">关闭</el-button>
      </span>
    </dialog-reset>

    <dialog-reset slotShow height="36vh" top="12vh" width="520px" title="启动应急预案" :visible.sync="startPlanVisible">
      <el-form ref="startPlanForm" :model="startPlanForm" :rules="startPlanRules" label-width="110px">
        <el-form-item label="事件等级" prop="eventLevel">
          <el-select v-model="startPlanForm.eventLevel" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in eventLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见" prop="opinion">
          <el-input v-model="startPlanForm.opinion" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入审批意见" />
        </el-form-item>
      </el-form>
      <span slot="dialog_footer">
        <el-button @click="startPlanVisible = false">取消</el-button>
        <el-button type="primary" :loading="actionLoading" @click="confirmStartPlan">确定</el-button>
      </span>
    </dialog-reset>

    <dialog-reset slotShow height="58vh" top="7vh" width="640px" title="结束事件" :visible.sync="closeVisible">
      <el-form ref="closeForm" :model="closeForm" :rules="closeRules" label-width="120px">
        <el-form-item label="事故原因" prop="closeReason">
          <el-input v-model="closeForm.closeReason" type="textarea" :rows="3" maxlength="1000" show-word-limit />
        </el-form-item>
        <el-form-item label="处置过程" prop="closeProcess">
          <el-input v-model="closeForm.closeProcess" type="textarea" :rows="3" maxlength="1000" show-word-limit />
        </el-form-item>
        <el-form-item label="伤亡情况" prop="casualties">
          <el-input v-model="closeForm.casualties" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="处置过程照片" prop="closePhotos">
          <el-upload class="close-photo-upload" :action="uploadAction" :headers="uploadHeaders" list-type="picture-card" :file-list="closePhotoFiles" :on-success="handleClosePhotoSuccess" :on-remove="handleClosePhotoRemove" :on-preview="handlePhotoPreview" :before-upload="beforePhotoUpload" accept="image/*">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="审批意见" prop="opinion">
          <el-input v-model="closeForm.opinion" type="textarea" :rows="2" maxlength="500" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="dialog_footer">
        <el-button @click="closeVisible = false">取消</el-button>
        <el-button type="primary" :loading="actionLoading" @click="confirmClose">确定</el-button>
      </span>
    </dialog-reset>

    <el-dialog :visible.sync="previewVisible" append-to-body width="720px">
      <img :src="previewUrl" class="preview-image" alt="">
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, getEventDetail, submitNext, backIncident, markFalseAlarm, startPlan, notifySafety, closeIncident, exportExcel } from './api'
import { downloadXls } from '@/util/util'
import { getSearchTimeConfig } from '@/basic-common/util/common'
import { getToken } from '@/util/auth'
import website from '@/config/website'

const EXPORT_MAX_ROWS = 10000
const TERMINAL_STATUS = [5, 6]
const INCIDENT_TYPES = [
  { label: '火灾', value: 'fire' },
  { label: '爆炸', value: 'explosion' },
  { label: '泄漏', value: 'leakage' },
  { label: '设备故障', value: 'equipment' },
  { label: '人员伤害', value: 'injury' },
  { label: '环保异常', value: 'environment' },
  { label: '其他', value: 'other' }
]
const STATUS_OPTIONS = [
  { label: '上报中', value: 1 },
  { label: '退回补充', value: 2 },
  { label: '已启动预案', value: 3 },
  { label: '已通知安环部', value: 4 },
  { label: '已结束', value: 5 },
  { label: '误报', value: 6 }
]
const EVENT_LEVELS = [
  { label: '一般事故', value: 1 },
  { label: '较大事故', value: 2 },
  { label: '重大事故', value: 3 },
  { label: '特别重大事故', value: 4 }
]
const NODE_OPTIONS = [
  { label: '发现者', value: 'reporter' },
  { label: '程序控制员', value: 'jks' },
  { label: '班长', value: 'team_leader' },
  { label: '调度中心', value: 'ddzx' },
  { label: '总经理(董事长)', value: 'zjl' },
  { label: '通知安环部', value: 'notify_safety' },
  { label: '结束事件', value: 'close' }
]

export default {
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      form: {},
      eventDetailVisible: false,
      eventDetailLoading: false,
      eventDetail: null,
      exportLoading: false,
      actionLoading: false,
      startPlanVisible: false,
      startPlanForm: { id: null, eventLevel: 1, opinion: '' },
      startPlanRules: {
        eventLevel: [{ required: true, message: '请选择事件等级', trigger: 'change' }]
      },
      closeVisible: false,
      closeForm: { id: null, closeReason: '', closeProcess: '', casualties: '', closePhotos: '', opinion: '' },
      closePhotoFiles: [],
      closeRules: {
        closeReason: [{ required: true, message: '请输入事故原因', trigger: 'blur' }],
        closeProcess: [{ required: true, message: '请输入处置过程', trigger: 'blur' }],
        casualties: [{ required: true, message: '请输入伤亡情况', trigger: 'blur' }],
        closePhotos: [{ required: true, message: '请上传处置过程照片', trigger: 'change' }]
      },
      previewVisible: false,
      previewUrl: '',
      incidentTypeOptions: INCIDENT_TYPES,
      statusOptions: STATUS_OPTIONS,
      eventLevelOptions: EVENT_LEVELS,
      nodeOptions: NODE_OPTIONS,
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        selection: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 420,
        column: [
          { label: '事件编号', prop: 'incidentNo', minWidth: 170, overHidden: true },
          { label: '关键词', prop: 'keyword', search: true, hide: true, addDisplay: false, editDisplay: false, viewDisplay: false },
          { label: '事故类型', prop: 'incidentType', type: 'select', search: true, slot: true, dicData: INCIDENT_TYPES, width: 120 },
          { label: '地点', prop: 'location', minWidth: 180, overHidden: true },
          { label: '简单描述', prop: 'briefDescription', minWidth: 220, overHidden: true },
          { label: '状态', prop: 'incidentStatus', type: 'select', search: true, slot: true, dicData: STATUS_OPTIONS, width: 120 },
          { label: '当前环节', prop: 'currentNodeCode', type: 'select', search: true, dicData: NODE_OPTIONS, formatter: (row) => row.currentNodeName || that.nodeLabel(row.currentNodeCode), width: 150 },
          { label: '负责对象', prop: 'currentTeamName', minWidth: 150, overHidden: true, formatter: (row) => row.currentHandlerUserName || row.currentTeamName || row.currentDeptName || '-' },
          { label: '事件等级', prop: 'eventLevel', type: 'select', search: true, slot: true, dicData: EVENT_LEVELS, width: 120 },
          { label: '上报人', prop: 'reporterName', width: 120, overHidden: true },
          { label: '上报时间', prop: 'reportTime', width: 170, overHidden: true },
          { label: '创建时间', prop: 'createTime', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss', width: 170, overHidden: true },
          { ...getSearchTimeConfig('', { type: 'datetimerange' }), paramsKey: ['startTime', 'endTime'] }
        ]
      },
      defaultParams: {}
    }
  },
  computed: {
    uploadAction () {
      return '/api/blade-resource/oss/endpoint/put-file-attach'
    },
    uploadHeaders () {
      const token = getToken()
      if (!token) return {}
      const bearer = 'Bearer ' + token
      return {
        Authorization: bearer,
        [website.tokenHeader]: bearer
      }
    },
    detailFields () {
      const detail = this.eventDetail || {}
      return [
        { label: '事件编号', value: detail.incidentNo },
        { label: '事故类型', value: this.incidentTypeLabel(detail.incidentType) },
        { label: '状态', value: this.statusLabel(detail.incidentStatus) },
        { label: '当前环节', value: detail.currentNodeName },
        { label: '负责班组', value: detail.currentTeamName },
        { label: '负责部门', value: detail.currentDeptName },
        { label: '负责人', value: detail.currentHandlerUserName },
        { label: '事件等级', value: this.eventLevelLabel(detail.eventLevel) },
        { label: '上报人', value: detail.reporterName },
        { label: '上报时间', value: detail.reportTime },
        { label: '地点', value: detail.location, wide: true },
        { label: '简单描述', value: detail.briefDescription, wide: true },
        { label: '启动预案时间', value: detail.planStartTime },
        { label: '通知安环部时间', value: detail.safetyNotifyTime },
        { label: '事故原因', value: detail.closeReason, wide: true },
        { label: '处置过程', value: detail.closeProcess, wide: true },
        { label: '伤亡情况', value: detail.casualties, wide: true },
        { label: '结束时间', value: detail.closeTime },
        { label: '创建时间', value: detail.createTime },
        { label: '更新时间', value: detail.updateTime }
      ]
    },
    detailFlowRecords () {
      return (this.eventDetail && this.eventDetail.flowRecords) || []
    }
  },
  methods: {
    showAction (row, prop) {
      return row && row[prop] === true && !this.isTerminal(row)
    },
    isTerminal (row) {
      return row && TERMINAL_STATUS.includes(Number(row.incidentStatus))
    },
    incidentTypeLabel (value) {
      return this.optionLabel(this.incidentTypeOptions, value)
    },
    statusLabel (value) {
      return this.optionLabel(this.statusOptions, Number(value))
    },
    eventLevelLabel (value) {
      return this.optionLabel(this.eventLevelOptions, Number(value))
    },
    nodeLabel (value) {
      return this.optionLabel(this.nodeOptions, value)
    },
    optionLabel (options, value) {
      const item = options.find(option => String(option.value) === String(value))
      return item ? item.label : (value || '-')
    },
    statusTagType (status) {
      const value = Number(status)
      if (value === 5) return 'success'
      if (value === 6) return 'info'
      if (value === 2) return 'warning'
      return 'primary'
    },
    imageList (value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(Boolean)
      return String(value).split(',').map(item => item.trim()).filter(Boolean)
    },
    showEventDetail (row) {
      this.eventDetailVisible = true
      this.eventDetailLoading = true
      this.eventDetail = null
      getEventDetail(row.id).then(({ data }) => {
        if (data.code === 200) {
          this.eventDetail = data.data || {}
        } else {
          this.$message.error(data.msg || '加载事件详情失败')
        }
      }).catch(() => {
        this.$message.error('加载事件详情失败')
      }).finally(() => {
        this.eventDetailLoading = false
      })
    },
    promptOpinion (title, placeholder) {
      return this.$prompt(placeholder || '请输入审批意见', title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => !!(value && value.trim()) || '请输入审批意见'
      })
    },
    submitAction (row) {
      this.promptOpinion('上报', '请输入上报意见').then(({ value }) => {
        return this.executeAction(() => submitNext({ id: row.id, opinion: value.trim() }))
      }).catch(() => {})
    },
    backAction (row) {
      this.promptOpinion('退回', '请输入退回原因').then(({ value }) => {
        return this.executeAction(() => backIncident({ id: row.id, opinion: value.trim() }))
      }).catch(() => {})
    },
    falseAlarmAction (row) {
      this.promptOpinion('误报', '请输入核实说明').then(({ value }) => {
        return this.executeAction(() => markFalseAlarm({ id: row.id, opinion: value.trim() }))
      }).catch(() => {})
    },
    notifySafetyAction (row) {
      this.$confirm('确定通知安环部吗？', '通知安环部', { type: 'warning' }).then(() => {
        return this.executeAction(() => notifySafety({ id: row.id, opinion: '通知安环部' }))
      }).catch(() => {})
    },
    openStartPlan (row) {
      this.startPlanForm = { id: row.id, eventLevel: row.eventLevel || 1, opinion: '' }
      this.startPlanVisible = true
      this.$nextTick(() => this.$refs.startPlanForm && this.$refs.startPlanForm.clearValidate())
    },
    confirmStartPlan () {
      this.$refs.startPlanForm.validate((valid) => {
        if (!valid) return
        this.executeAction(() => startPlan({ ...this.startPlanForm })).then(() => {
          this.startPlanVisible = false
        })
      })
    },
    openClose (row) {
      this.closeForm = { id: row.id, closeReason: '', closeProcess: '', casualties: '', closePhotos: '', opinion: '' }
      this.closePhotoFiles = []
      this.closeVisible = true
      this.$nextTick(() => this.$refs.closeForm && this.$refs.closeForm.clearValidate())
    },
    confirmClose () {
      this.closeForm.closePhotos = this.closePhotoFiles.map(item => item.url).filter(Boolean).join(',')
      this.$refs.closeForm.validate((valid) => {
        if (!valid) return
        this.executeAction(() => closeIncident({ ...this.closeForm })).then(() => {
          this.closeVisible = false
        })
      })
    },
    executeAction (request) {
      this.actionLoading = true
      return request().then(({ data }) => {
        if (data.code === 200) {
          this.$message.success(data.msg || '操作成功')
          this.onLoad(this.page)
        } else {
          this.$message.error(data.msg || '操作失败')
        }
      }).finally(() => {
        this.actionLoading = false
      })
    },
    beforePhotoUpload (file) {
      const isImage = file.type && file.type.indexOf('image/') === 0
      if (!isImage) {
        this.$message.warning('请上传图片文件')
      }
      return isImage
    },
    handleClosePhotoSuccess (res, file, fileList) {
      const url = this.resolveUploadUrl(res)
      if (url) {
        file.url = url
      }
      this.closePhotoFiles = fileList.map(item => ({ ...item, url: item.url || this.resolveUploadUrl(item.response) })).filter(item => item.url)
      this.closeForm.closePhotos = this.closePhotoFiles.map(item => item.url).join(',')
      this.$nextTick(() => this.$refs.closeForm && this.$refs.closeForm.validateField('closePhotos'))
    },
    handleClosePhotoRemove (file, fileList) {
      this.closePhotoFiles = fileList.map(item => ({ ...item, url: item.url || this.resolveUploadUrl(item.response) })).filter(item => item.url)
      this.closeForm.closePhotos = this.closePhotoFiles.map(item => item.url).join(',')
    },
    handlePhotoPreview (file) {
      this.previewUrl = file.url || this.resolveUploadUrl(file.response)
      this.previewVisible = !!this.previewUrl
    },
    resolveUploadUrl (res) {
      if (!res) return ''
      const data = res.data || {}
      return data.link || data.url || data.fileUrl || data.fullLink || ''
    },
    async handleExport () {
      if (!this.page.total) {
        this.$message.warning('无数据可导出')
        return
      }
      if (this.page.total > EXPORT_MAX_ROWS) {
        this.$message.warning(`当前结果超过${EXPORT_MAX_ROWS}条，仅导出前${EXPORT_MAX_ROWS}条，请缩小筛选范围`)
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel({ ...params, page: 1, size: EXPORT_MAX_ROWS })
        downloadXls(res.data, `应急工单审批_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
.event-detail-dialog {
  min-height: 360px;
  padding: 4px 8px 0;
}
.detail-section {
  margin-bottom: 18px;
}
.detail-section__title {
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}
.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
.detail-item--wide {
  grid-column: span 2;
}
.detail-item__label {
  flex: 0 0 110px;
  padding: 10px 12px;
  background: #f5f7fa;
  color: #606266;
}
.detail-item__value {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  color: #303133;
  word-break: break-all;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.detail-image {
  width: 96px;
  height: 96px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #909399;
  background: #f5f7fa;
}
.close-photo-upload ::v-deep .el-upload--picture-card,
.close-photo-upload ::v-deep .el-upload-list__item {
  width: 96px;
  height: 96px;
  line-height: 96px;
}
.preview-image {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
</style>
